// Route: '/newgame'
import React, { useContext, useState } from 'react';
import Nav from '../../components/Nav/Nav';
import TextInput from '../../components/TextInput/TextInput';
import styles from './NewGamePage.module.css';
import { useHistory } from 'react-router-dom';
import { StoreContext } from '../../utils/store';

const NewGamePage = () => {
  const history = useHistory();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;

  const [titleInput, setTitleInput] = useState('');

  const enter = (e) => {
    if (e.key === 'Enter') {
      confirm();
    }
  }

  const confirm = async () => {
    if (!titleInput) {
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Warning!',
        modalBodyText: 'Quiz name can\'t not be empty',
        modalColors: 'warning',
      }));
    } else {
      const response = await api.makeAPIRequest('admin/quiz/new', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          name: titleInput,
        })
      });
      try {
        const json = await response.json();
        if (response.status === 200) {
          history.push('/');
        } else {
          setModalStatus(status => ({
            ...status,
            modalActive: true,
            overlayActive: true,
            modalHeaderText: 'Error',
            modalBodyText: json.error,
            modalColors: 'error',
          }));
        }
      } catch (e) {
        console.log('ERROR', e);
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: 'Sorry! Can\' connect to the server.',
          modalColors: 'error',
        }));
      }
    }
  }

  return (
    <section>
      <Nav
        visibilities={['false', 'false', 'false', 'true', 'true']}
        exit={() => history.push('/')}
        confirm={confirm}
      />
      <div className={styles.main}>
      <h2>Add a new game</h2>
        <TextInput
          label="Name"
          name='new-game'
          value={titleInput}
          onKeyDown={enter}
          onChange={e => setTitleInput(e.target.value)} />
      </div>
    </section>
  );
};

export default NewGamePage;
